import * as React from "react"
import Layout from "../Components/Layout";

export default function Privacy() {
  return (
    <main>
      <title>Fietsen Marijnissen :: Koop een fiets bij de man die hem ook vakkundig herstellen kan!</title>
      <Layout>
        <h1>Privacy Statement</h1>
        <h2>Verwerking van persoonsgegevens</h2>
        <p>De persoonlijke gegevens die u op de site invult worden uitsluitend door ons zelf gebruikt ten behoeve van het aangegeven doel, zoals het bestellen van producten.</p>
        
        <h2>Gebruik van cookies</h2>
        <p>Fietsen Marijnissen maakt bij het aanbieden van haar diensten gebruik van cookies. Dit is een klein eenvoudig bestandje met gegevens die of op de harde schijf van uw computer wordt opgeslagen of in de sessie van uw browser staat.</p>
        
        <p>De sessie-cookie bevat geen persoonsgegevens en dient enkel om het gebruik van onze website voor u gemakkelijker te maken.</p>
        
        <h2>Fietsen Marijnissen en andere websites</h2>
        <p>Op onze site treft u een aantal links aan naar andere websites. Wij kunnen echter geen verantwoordelijkheid dragen met betrekking tot de omgang door die partijen met uw gegevens en voor de inhoud van deze sites. Lees hiervoor de privacyverklaring/privacystatement, indien aanwezig, van de site die u bezoekt.</p>
      </Layout>
    </main>
  );
}
